import React from "react";
import Logo from "shared/Logo/Logo";
import img from "../images/under-construction.jpg";

const ComingSoon: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <svg
        width="592"
        height="400"
        viewBox="0 0 592 592"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M312.268 28.416V347.824"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g opacity="0.3">
          <path
            d="M385.155 472.582H96.1765C93.005 472.582 90.4341 475.152 90.4341 478.324V519.906C90.4341 523.077 93.005 525.648 96.1765 525.648H385.155C388.327 525.648 390.898 523.077 390.898 519.906V478.324C390.898 475.152 388.327 472.582 385.155 472.582Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M115.89 441.75H365.442C368.01 441.75 370.474 442.77 372.29 444.587C374.106 446.403 375.127 448.866 375.127 451.435V525.696H106.205V451.435C106.205 448.866 107.225 446.403 109.042 444.587C110.858 442.77 113.321 441.75 115.89 441.75Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M375.115 491.229H106.205V525.648H375.115V491.229Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30.7249 525.861H580.622"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M565.04 441.75H434.635V525.648H565.04V441.75Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M496.203 449.043H439.915V477.246H496.203V449.043Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M558.516 449.043H502.229V477.246H558.516V449.043Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M496.203 483.877H439.915V512.08H496.203V483.877Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M558.516 483.877H502.229V512.08H558.516V483.877Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M565.04 434.942H434.635V441.75H565.04V434.942Z"
            fill="white"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M498.642 389.796C498.128 388.441 497.127 387.327 495.835 386.67C494.544 386.013 493.054 385.861 491.656 386.244L487.441 381.508C487.598 380.966 487.592 380.389 487.423 379.85C487.255 379.311 486.932 378.834 486.494 378.477C486.215 378.167 485.876 377.917 485.497 377.742C485.119 377.567 484.708 377.471 484.292 377.459C483.444 377.468 482.634 377.812 482.037 378.415C481.441 379.018 481.107 379.831 481.107 380.679C481.104 381.084 481.176 381.485 481.32 381.863L455.509 405.638C455.116 405.441 454.686 405.329 454.247 405.31C453.808 405.292 453.37 405.367 452.963 405.532C452.295 405.786 451.731 406.257 451.361 406.869C450.991 407.48 450.836 408.198 450.92 408.908C451.004 409.618 451.323 410.28 451.826 410.788C452.33 411.296 452.988 411.621 453.697 411.712L457.498 426.595H449.802C449.157 426.595 448.519 426.722 447.923 426.969C447.328 427.216 446.787 427.578 446.331 428.035C445.876 428.491 445.515 429.033 445.27 429.629C445.024 430.225 444.898 430.864 444.9 431.509V435.274H474.784V431.509C474.784 430.205 474.266 428.956 473.345 428.034C472.423 427.113 471.174 426.595 469.87 426.595H459.972L456.03 411.132C456.445 410.837 456.784 410.447 457.017 409.993C457.25 409.54 457.37 409.037 457.367 408.527C457.368 408.123 457.296 407.722 457.154 407.343L482.918 383.616C483.361 383.831 483.847 383.944 484.339 383.947C484.919 383.943 485.487 383.784 485.985 383.486L489.537 387.369C488.592 388.142 487.914 389.192 487.599 390.372C487.285 391.551 487.35 392.8 487.784 393.94L490.318 400.523L501.223 396.332L498.642 389.796Z"
            fill="black"
            stroke="black"
            stroke-miterlimit="10"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M81.0922 453.946C81.0922 453.946 81.7552 451.128 81.7789 450.938C81.992 448.819 81.1751 444.568 78.9728 443.598C78.6035 443.449 78.2072 443.38 77.8095 443.394C77.4118 443.408 77.0215 443.506 76.6636 443.68C76.3056 443.854 75.9881 444.1 75.7312 444.404C75.4744 444.708 75.284 445.063 75.1722 445.445C75.0037 446.291 75.0224 447.164 75.2269 448.003C75.4315 448.841 75.8169 449.625 76.3562 450.299C77.4455 451.826 81.0922 453.946 81.0922 453.946Z"
            fill="black"
          />
          <path
            d="M38.5155 454.526C40.2678 455.212 44.4355 454.976 44.4355 454.976C44.4355 454.976 43.4291 452.252 43.3462 452.087C42.3517 450.192 39.3206 447.102 36.9645 447.505C36.5818 447.589 36.2207 447.752 35.9036 447.982C35.5865 448.212 35.3202 448.505 35.1214 448.843C34.9226 449.181 34.7954 449.556 34.7479 449.945C34.7003 450.334 34.7334 450.728 34.8451 451.104C35.169 451.908 35.6656 452.632 36.2998 453.223C36.9341 453.814 37.6905 454.259 38.5155 454.526Z"
            fill="black"
          />
          <path
            d="M40.3982 466.662C42.186 466.851 45.9038 465.632 46.1998 465.537C46.9001 467.66 47.7346 469.736 48.698 471.753C49.2545 472.937 49.882 474.121 50.474 475.305C50.1188 474.82 49.7873 474.381 49.7399 474.334C48.2836 472.759 44.5422 470.581 42.3636 471.599C42.0081 471.778 41.6941 472.03 41.4421 472.338C41.1902 472.646 41.0057 473.004 40.9008 473.388C40.7959 473.772 40.7728 474.174 40.833 474.567C40.8933 474.961 41.0356 475.337 41.2506 475.672C41.7784 476.356 42.4493 476.915 43.2163 477.312C43.9833 477.709 44.8278 477.933 45.6906 477.969C47.6135 477.902 49.5145 477.539 51.3265 476.892C51.5751 477.341 51.8001 477.791 52.0487 478.229C53.2327 480.361 54.4167 482.468 55.4705 484.588C55.8494 485.322 56.1927 486.068 56.5479 486.813C56.2282 486.387 55.9559 486.02 55.9086 485.973C54.4522 484.398 50.7108 482.231 48.5441 483.238C48.1886 483.417 47.8746 483.669 47.6226 483.977C47.3706 484.285 47.1862 484.643 47.0813 485.027C46.9763 485.411 46.9533 485.812 47.0135 486.206C47.0738 486.599 47.2161 486.976 47.4311 487.311C47.9576 487.993 48.6266 488.552 49.3914 488.948C50.1563 489.345 50.9985 489.57 51.8593 489.608C53.7327 489.55 55.5859 489.203 57.353 488.578C57.6846 489.359 58.0279 490.129 58.3239 490.946C58.5015 491.478 58.7265 491.964 58.8804 492.508C59.0343 493.053 59.2238 493.562 59.3895 494.083C59.6618 495.101 59.9697 496.143 60.2183 497.15C60.3959 497.836 60.5498 498.5 60.7156 499.163C60.3367 498.428 59.5316 496.984 59.5316 496.866C58.3476 495.09 54.9614 492.378 52.6644 493.053C52.2952 493.176 51.955 493.372 51.6646 493.631C51.3742 493.89 51.1397 494.205 50.9756 494.557C50.8115 494.91 50.7212 495.293 50.7103 495.681C50.6994 496.07 50.768 496.457 50.9121 496.818C51.3306 497.572 51.9088 498.226 52.6061 498.733C53.3035 499.24 54.1033 499.589 54.9495 499.755C56.923 499.976 58.9185 499.9 60.8695 499.53C61.13 500.631 61.3786 501.708 61.5918 502.726C62.3495 506.278 62.835 509.227 63.1546 511.31L64.7767 511.251V511.062C64.4215 508.966 63.8532 505.971 63.0126 502.419C62.7521 501.294 62.4561 500.051 62.1246 498.867C63.2324 498.383 64.3081 497.83 65.345 497.209C66.8315 498.403 68.4774 499.383 70.235 500.122C69.8442 501.187 69.4535 502.217 69.051 503.188C67.7249 506.551 66.4935 509.298 65.6174 511.204H67.3934C68.2103 509.309 69.2641 506.776 70.377 503.756C70.7796 502.679 71.1822 501.507 71.561 500.311C73.5098 500.698 75.5067 500.782 77.481 500.56C78.3283 500.397 79.1297 500.051 79.8292 499.545C80.5287 499.04 81.1093 498.388 81.5303 497.635C81.6995 497.264 81.787 496.862 81.7868 496.454C81.7866 496.046 81.6987 495.644 81.5291 495.273C81.3595 494.902 81.1122 494.573 80.804 494.306C80.4957 494.04 80.1337 493.842 79.7425 493.728C77.4455 493.041 74.0711 495.753 72.8634 497.517C72.7924 497.623 72.1412 498.831 71.7505 499.612L72.2359 498.132C72.5674 497.138 72.8634 496.131 73.1831 495.042L73.6094 493.444C73.7514 492.911 73.8462 492.331 73.9764 491.763C74.2369 490.46 74.4382 489.122 74.6158 487.772C76.4166 488.415 78.3052 488.779 80.2161 488.85C81.0732 488.823 81.9142 488.609 82.6808 488.225C83.4474 487.841 84.1214 487.294 84.6561 486.624C84.8757 486.292 85.0223 485.916 85.0863 485.523C85.1503 485.13 85.1301 484.727 85.0272 484.343C84.9243 483.958 84.7409 483.599 84.4891 483.29C84.2374 482.981 83.923 482.729 83.5668 482.551C81.3882 481.521 77.6468 483.735 76.1905 485.251C76.0958 485.345 75.1722 486.577 74.675 487.275C74.7697 486.458 74.8762 485.641 74.9473 484.824C75.1604 482.456 75.3025 480.017 75.4446 477.602C75.4446 476.856 75.5511 476.122 75.5985 475.388C75.9063 475.483 79.6004 476.714 81.4001 476.572C82.261 476.539 83.1043 476.318 83.8712 475.926C84.6381 475.533 85.31 474.978 85.8401 474.299C86.0574 473.965 86.2018 473.589 86.264 473.196C86.3261 472.802 86.3045 472.4 86.2005 472.016C86.0966 471.631 85.9127 471.273 85.6608 470.965C85.409 470.656 85.0948 470.404 84.739 470.226C82.5722 469.195 78.819 471.41 77.3626 472.925C77.2561 473.043 75.93 474.819 75.6103 475.293C75.7287 473.671 75.8471 472.049 76.0484 470.462C76.3097 468.313 76.7052 466.181 77.2324 464.081C77.3863 464.14 81.2343 465.43 83.0695 465.265C83.9304 465.232 84.7738 465.011 85.5406 464.618C86.3075 464.226 86.9794 463.671 87.5095 462.991C87.7486 462.656 87.9115 462.272 87.9868 461.866C88.0621 461.461 88.0479 461.044 87.9453 460.645C87.8427 460.246 87.6541 459.874 87.3927 459.555C87.1313 459.237 86.8035 458.979 86.4321 458.8C84.2654 457.77 80.5121 459.984 79.0557 461.5C78.961 461.594 77.9428 462.956 77.481 463.619L77.3508 463.56C77.9555 461.46 78.748 459.419 79.7188 457.462C80.2279 456.373 80.7726 455.366 81.3172 454.396C83.0678 455.245 84.9355 455.827 86.8583 456.124C87.7183 456.186 88.5814 456.059 89.3871 455.752C90.1929 455.445 90.9219 454.966 91.5233 454.348C91.776 454.041 91.9612 453.684 92.0665 453.3C92.1719 452.916 92.1952 452.515 92.1349 452.121C92.0745 451.728 91.9319 451.352 91.7164 451.018C91.5008 450.683 91.2172 450.398 90.8839 450.18C88.8474 448.925 84.881 450.654 83.259 452.051C83.1642 452.122 82.3473 452.998 81.7671 453.638C82.0276 453.2 82.2762 452.75 82.5367 452.335C83.4839 450.796 84.4548 449.435 85.3073 448.239C85.8046 447.564 86.2663 446.972 86.7044 446.415C88.6434 446.367 90.5637 446.023 92.3994 445.397C93.1902 445.054 93.8966 444.543 94.4692 443.899C95.0418 443.254 95.4669 442.493 95.7146 441.668C95.7964 441.279 95.7954 440.877 95.7118 440.489C95.6281 440.101 95.4637 439.735 95.2292 439.414C94.9946 439.093 94.6953 438.826 94.3505 438.629C94.0058 438.432 93.6234 438.309 93.2282 438.269C90.8602 438.092 88.1133 441.454 87.3082 443.444C87.2372 443.609 86.4557 446.427 86.5031 446.415C86.0769 446.948 85.6151 447.516 85.1297 448.156C84.2417 449.34 83.2471 450.666 82.2526 452.193C81.1739 453.833 80.1896 455.533 79.3044 457.284C78.3083 459.24 77.4881 461.281 76.8535 463.382C76.855 463.41 76.855 463.437 76.8535 463.465C76.8535 462.766 76.747 460.801 76.7114 460.647C76.3681 458.54 74.45 454.668 72.082 454.313C71.686 454.264 71.2843 454.3 70.9029 454.417C70.5216 454.535 70.1693 454.731 69.8689 454.993C69.5684 455.256 69.3266 455.579 69.1592 455.941C68.9917 456.303 68.9024 456.696 68.897 457.095C68.9616 457.955 69.2134 458.791 69.6347 459.543C70.056 460.296 70.6367 460.947 71.3361 461.452C72.7214 462.636 76.4865 463.631 76.7943 463.714C76.1991 465.872 75.7481 468.067 75.4446 470.285C75.267 471.575 75.113 472.878 74.9946 474.18C74.9946 473.576 74.9236 472.996 74.9118 472.996C74.5684 470.889 72.6503 467.005 70.2705 466.65C69.8757 466.605 69.476 466.644 69.0969 466.763C68.7178 466.881 68.3677 467.078 68.069 467.34C67.7703 467.602 67.5296 467.923 67.3623 468.284C67.195 468.644 67.1047 469.035 67.0974 469.432C67.165 470.293 67.4179 471.13 67.8389 471.884C68.2599 472.638 68.839 473.292 69.5364 473.801C71.1544 474.781 72.9106 475.511 74.746 475.968L74.5921 477.484C74.3908 479.852 74.2014 482.314 73.9409 484.67C73.8462 485.499 73.7278 486.316 73.6094 487.133C73.6094 486.6 73.6094 486.139 73.6094 486.079C73.2542 483.96 71.3361 480.088 68.9681 479.733C68.5726 479.685 68.1715 479.72 67.7908 479.838C67.4101 479.955 67.0585 480.152 66.7589 480.414C66.4594 480.677 66.2187 481 66.0526 481.362C65.8865 481.724 65.7987 482.117 65.795 482.516C65.8511 483.37 66.0919 484.202 66.5007 484.954C66.9096 485.706 67.4767 486.361 68.163 486.873C69.7548 487.865 71.4928 488.6 73.3134 489.051C73.1594 489.88 73.0174 490.721 72.8398 491.514C72.7095 492.059 72.6148 492.591 72.449 493.124C72.2833 493.657 72.1412 494.202 71.9991 494.723C71.6676 495.729 71.3361 496.759 71.0046 497.73C70.7678 498.405 70.531 499.044 70.2942 499.695C70.4007 498.867 70.5665 497.244 70.5546 497.102C70.4679 495.221 69.8969 493.394 68.897 491.798C68.8944 491.588 68.8746 491.378 68.8378 491.171C68.7741 490.778 68.6283 490.403 68.4098 490.07C68.1913 489.737 67.9052 489.455 67.5699 489.24C67.2347 489.025 66.858 488.884 66.4644 488.825C66.0709 488.766 65.6692 488.791 65.2858 488.897C62.9889 489.596 61.6628 493.704 61.6273 495.847C61.6273 495.978 61.7575 497.351 61.8522 498.215C61.722 497.718 61.5918 497.221 61.4497 496.712C61.1774 495.693 60.8577 494.687 60.538 493.61L60.0052 492.047C59.8276 491.514 59.5908 490.981 59.3895 490.448C58.8804 489.205 58.3121 487.974 57.7082 486.754C59.5691 486.295 61.3496 485.557 62.9889 484.564C63.6868 484.06 64.2666 483.411 64.6878 482.66C65.1091 481.91 65.3616 481.077 65.4279 480.219C65.4275 479.82 65.3425 479.426 65.1784 479.062C65.0144 478.699 64.775 478.374 64.4762 478.11C64.1774 477.846 63.8259 477.648 63.445 477.53C63.0641 477.412 62.6625 477.376 62.2666 477.424C59.8986 477.768 57.9569 481.628 57.6017 483.747C57.6017 483.877 57.4951 485.416 57.4596 486.269C57.0926 485.535 56.7374 484.801 56.3348 484.067C55.1508 481.959 53.9668 479.863 52.7828 477.768L51.6817 475.838C52.0014 475.755 55.7665 474.737 57.1518 473.6C57.8519 473.098 58.4339 472.449 58.8573 471.698C59.2806 470.948 59.535 470.114 59.6026 469.255C59.5919 468.861 59.4996 468.473 59.3315 468.116C59.1635 467.76 58.9234 467.442 58.6264 467.183C58.3294 466.924 57.9819 466.729 57.6058 466.61C57.2297 466.492 56.8332 466.453 56.4414 466.496C54.0734 466.839 52.1316 470.711 51.7764 472.819C51.7764 472.984 51.6225 475.187 51.6225 475.767C50.8174 474.346 50.0359 472.937 49.2545 471.504C48.2743 469.59 47.4239 467.612 46.7089 465.584C46.851 465.584 50.7818 464.507 52.2026 463.335C52.9028 462.832 53.4848 462.183 53.9081 461.433C54.3315 460.682 54.5858 459.848 54.6535 458.989C54.6513 458.591 54.565 458.198 54.4003 457.835C54.2356 457.473 53.9963 457.149 53.6979 456.885C53.3995 456.621 53.0488 456.424 52.6687 456.305C52.2886 456.186 51.8877 456.149 51.4922 456.195C49.1242 456.539 47.1825 460.41 46.8273 462.518C46.8273 462.66 46.7089 464.353 46.6852 465.158H46.5431C45.8701 463.087 45.3866 460.959 45.0986 458.8C44.921 457.616 44.8263 456.432 44.7434 455.366C46.6735 455.117 48.5541 454.574 50.3201 453.756C51.0907 453.329 51.7564 452.736 52.2684 452.019C52.7805 451.302 53.1261 450.48 53.2801 449.612C53.3217 449.216 53.2794 448.816 53.156 448.438C53.0325 448.06 52.8307 447.712 52.5636 447.417C52.2966 447.122 51.9704 446.887 51.6062 446.726C51.2421 446.566 50.8482 446.484 50.4503 446.486C48.0823 446.569 45.7143 450.204 45.1105 452.264C45.1105 452.371 44.8855 453.543 44.7553 454.407C44.7553 453.898 44.6842 453.377 44.6724 452.904C44.6132 451.092 44.6724 449.423 44.6724 447.955C44.6724 447.114 44.7671 446.356 44.8263 445.646C46.4435 444.537 47.8777 443.183 49.0769 441.632C49.5494 440.911 49.8588 440.096 49.9836 439.243C50.1083 438.39 50.0454 437.521 49.7991 436.695C49.6508 436.325 49.4266 435.99 49.1411 435.712C48.8556 435.435 48.515 435.22 48.1414 435.081C47.7678 434.943 47.3693 434.884 46.9717 434.909C46.574 434.934 46.1861 435.042 45.8327 435.227C43.7489 436.411 43.3345 440.708 43.7607 442.804C43.7607 442.982 44.7079 445.752 44.7434 445.729C44.6724 446.403 44.6132 447.138 44.554 447.931C44.4593 449.399 44.3646 451.068 44.3882 452.892C44.3843 454.87 44.4989 456.847 44.7316 458.812C44.98 460.994 45.4238 463.15 46.0577 465.253C46.0525 465.276 46.0525 465.3 46.0577 465.324C45.6551 464.744 44.4948 463.169 44.3882 463.051C42.9319 461.488 39.1905 459.309 37.0238 460.327C36.6682 460.506 36.3543 460.758 36.1023 461.066C35.8503 461.375 35.6659 461.732 35.5609 462.116C35.456 462.5 35.4329 462.902 35.4932 463.295C35.5535 463.689 35.6957 464.065 35.9108 464.4C36.4471 465.083 37.1271 465.64 37.9026 466.031C38.6781 466.422 39.5301 466.637 40.3982 466.662Z"
            fill="black"
          />
          <path
            opacity="0.3"
            d="M38.5155 454.526C40.2678 455.212 44.4355 454.976 44.4355 454.976C44.4355 454.976 43.4291 452.252 43.3462 452.087C42.3517 450.192 39.3206 447.102 36.9645 447.505C36.5818 447.589 36.2207 447.752 35.9036 447.982C35.5865 448.212 35.3202 448.505 35.1214 448.843C34.9226 449.181 34.7954 449.556 34.7479 449.945C34.7003 450.334 34.7334 450.728 34.8451 451.104C35.169 451.908 35.6656 452.632 36.2998 453.223C36.9341 453.814 37.6905 454.259 38.5155 454.526Z"
            fill="black"
          />
          <path
            opacity="0.3"
            d="M81.0922 453.946C81.0922 453.946 81.7552 451.128 81.7789 450.938C81.992 448.819 81.1751 444.568 78.9728 443.598C78.6035 443.449 78.2072 443.38 77.8095 443.394C77.4118 443.408 77.0215 443.506 76.6636 443.68C76.3056 443.854 75.9881 444.1 75.7312 444.404C75.4744 444.708 75.284 445.063 75.1722 445.445C75.0037 446.291 75.0224 447.164 75.2269 448.003C75.4315 448.841 75.8169 449.625 76.3562 450.299C77.4455 451.826 81.0922 453.946 81.0922 453.946Z"
            fill="black"
          />
          <path
            opacity="0.3"
            d="M40.3982 466.662C42.186 466.851 45.9038 465.632 46.1998 465.537C46.9001 467.66 47.7346 469.736 48.698 471.753C49.2545 472.937 49.882 474.121 50.474 475.305C50.1188 474.82 49.7873 474.381 49.7399 474.334C48.2836 472.759 44.5422 470.581 42.3636 471.599C42.0081 471.778 41.6941 472.03 41.4421 472.338C41.1902 472.646 41.0057 473.004 40.9008 473.388C40.7959 473.772 40.7728 474.174 40.833 474.567C40.8933 474.961 41.0356 475.337 41.2506 475.672C41.7784 476.356 42.4493 476.915 43.2163 477.312C43.9833 477.709 44.8278 477.933 45.6906 477.969C47.6135 477.902 49.5145 477.539 51.3265 476.892C51.5751 477.341 51.8001 477.791 52.0487 478.229C53.2327 480.361 54.4167 482.468 55.4705 484.588C55.8494 485.322 56.1927 486.068 56.5479 486.813C56.2282 486.387 55.9559 486.02 55.9086 485.973C54.4522 484.398 50.7108 482.231 48.5441 483.238C48.1886 483.417 47.8746 483.669 47.6226 483.977C47.3706 484.285 47.1862 484.643 47.0813 485.027C46.9763 485.411 46.9533 485.812 47.0135 486.206C47.0738 486.599 47.2161 486.976 47.4311 487.311C47.9576 487.993 48.6266 488.552 49.3914 488.948C50.1563 489.345 50.9985 489.57 51.8593 489.608C53.7327 489.55 55.5859 489.203 57.353 488.578C57.6846 489.359 58.0279 490.129 58.3239 490.946C58.5015 491.478 58.7265 491.964 58.8804 492.508C59.0343 493.053 59.2238 493.562 59.3895 494.083C59.6618 495.101 59.9697 496.143 60.2183 497.15C60.3959 497.836 60.5498 498.5 60.7156 499.163C60.3367 498.428 59.5316 496.984 59.5316 496.866C58.3476 495.09 54.9614 492.378 52.6644 493.053C52.2952 493.176 51.955 493.372 51.6646 493.631C51.3742 493.89 51.1397 494.205 50.9756 494.557C50.8115 494.91 50.7212 495.293 50.7103 495.681C50.6994 496.07 50.768 496.457 50.9121 496.818C51.3306 497.572 51.9088 498.226 52.6061 498.733C53.3035 499.24 54.1033 499.589 54.9495 499.755C56.923 499.976 58.9185 499.9 60.8695 499.53C61.13 500.631 61.3786 501.708 61.5918 502.726C62.3495 506.278 62.835 509.227 63.1546 511.31L64.7767 511.251V511.062C64.4215 508.966 63.8532 505.971 63.0126 502.419C62.7521 501.294 62.4561 500.051 62.1246 498.867C63.2324 498.383 64.3081 497.83 65.345 497.209C66.8315 498.403 68.4774 499.383 70.235 500.122C69.8442 501.187 69.4535 502.217 69.051 503.188C67.7249 506.551 66.4935 509.298 65.6174 511.204H67.3934C68.2103 509.309 69.2641 506.776 70.377 503.756C70.7796 502.679 71.1822 501.507 71.561 500.311C73.5098 500.698 75.5067 500.782 77.481 500.56C78.3283 500.397 79.1297 500.051 79.8292 499.545C80.5287 499.04 81.1093 498.388 81.5303 497.635C81.6995 497.264 81.787 496.862 81.7868 496.454C81.7866 496.046 81.6987 495.644 81.5291 495.273C81.3595 494.902 81.1122 494.573 80.804 494.306C80.4957 494.04 80.1337 493.842 79.7425 493.728C77.4455 493.041 74.0711 495.753 72.8634 497.517C72.7924 497.623 72.1412 498.831 71.7505 499.612L72.2359 498.132C72.5674 497.138 72.8634 496.131 73.1831 495.042L73.6094 493.444C73.7514 492.911 73.8462 492.331 73.9764 491.763C74.2369 490.46 74.4382 489.122 74.6158 487.772C76.4166 488.415 78.3052 488.779 80.2161 488.85C81.0732 488.823 81.9142 488.609 82.6808 488.225C83.4474 487.841 84.1214 487.294 84.6561 486.624C84.8757 486.292 85.0223 485.916 85.0863 485.523C85.1503 485.13 85.1301 484.727 85.0272 484.343C84.9243 483.958 84.7409 483.599 84.4891 483.29C84.2374 482.981 83.923 482.729 83.5668 482.551C81.3882 481.521 77.6468 483.735 76.1905 485.251C76.0958 485.345 75.1722 486.577 74.675 487.275C74.7697 486.458 74.8762 485.641 74.9473 484.824C75.1604 482.456 75.3025 480.017 75.4446 477.602C75.4446 476.856 75.5511 476.122 75.5985 475.388C75.9063 475.483 79.6004 476.714 81.4001 476.572C82.261 476.539 83.1043 476.318 83.8712 475.926C84.6381 475.533 85.31 474.978 85.8401 474.299C86.0574 473.965 86.2018 473.589 86.264 473.196C86.3261 472.802 86.3045 472.4 86.2005 472.016C86.0966 471.631 85.9127 471.273 85.6608 470.965C85.409 470.656 85.0948 470.404 84.739 470.226C82.5722 469.195 78.819 471.41 77.3626 472.925C77.2561 473.043 75.93 474.819 75.6103 475.293C75.7287 473.671 75.8471 472.049 76.0484 470.462C76.3097 468.313 76.7052 466.181 77.2324 464.081C77.3863 464.14 81.2343 465.43 83.0695 465.265C83.9304 465.232 84.7738 465.011 85.5406 464.618C86.3075 464.226 86.9794 463.671 87.5095 462.991C87.7486 462.656 87.9115 462.272 87.9868 461.866C88.0621 461.461 88.0479 461.044 87.9453 460.645C87.8427 460.246 87.6541 459.874 87.3927 459.555C87.1313 459.237 86.8035 458.979 86.4321 458.8C84.2654 457.77 80.5121 459.984 79.0557 461.5C78.961 461.594 77.9428 462.956 77.481 463.619L77.3508 463.56C77.9555 461.46 78.748 459.419 79.7188 457.462C80.2279 456.373 80.7726 455.366 81.3172 454.396C83.0678 455.245 84.9355 455.827 86.8583 456.124C87.7183 456.186 88.5814 456.059 89.3871 455.752C90.1929 455.445 90.9219 454.966 91.5233 454.348C91.776 454.041 91.9612 453.684 92.0665 453.3C92.1719 452.916 92.1952 452.515 92.1349 452.121C92.0745 451.728 91.9319 451.352 91.7164 451.018C91.5008 450.683 91.2172 450.398 90.8839 450.18C88.8474 448.925 84.881 450.654 83.259 452.051C83.1642 452.122 82.3473 452.998 81.7671 453.638C82.0276 453.2 82.2762 452.75 82.5367 452.335C83.4839 450.796 84.4548 449.435 85.3073 448.239C85.8046 447.564 86.2663 446.972 86.7044 446.415C88.6434 446.367 90.5637 446.023 92.3994 445.397C93.1902 445.054 93.8966 444.543 94.4692 443.899C95.0418 443.254 95.4669 442.493 95.7146 441.668C95.7964 441.279 95.7954 440.877 95.7118 440.489C95.6281 440.101 95.4637 439.735 95.2292 439.414C94.9946 439.093 94.6953 438.826 94.3505 438.629C94.0058 438.432 93.6234 438.309 93.2282 438.269C90.8602 438.092 88.1133 441.454 87.3082 443.444C87.2372 443.609 86.4557 446.427 86.5031 446.415C86.0769 446.948 85.6151 447.516 85.1297 448.156C84.2417 449.34 83.2471 450.666 82.2526 452.193C81.1739 453.833 80.1896 455.533 79.3044 457.284C78.3083 459.24 77.4881 461.281 76.8535 463.382C76.855 463.41 76.855 463.437 76.8535 463.465C76.8535 462.766 76.747 460.801 76.7114 460.647C76.3681 458.54 74.45 454.668 72.082 454.313C71.686 454.264 71.2843 454.3 70.9029 454.417C70.5216 454.535 70.1693 454.731 69.8689 454.993C69.5684 455.256 69.3266 455.579 69.1592 455.941C68.9917 456.303 68.9024 456.696 68.897 457.095C68.9616 457.955 69.2134 458.791 69.6347 459.543C70.056 460.296 70.6367 460.947 71.3361 461.452C72.7214 462.636 76.4865 463.631 76.7943 463.714C76.1991 465.872 75.7481 468.067 75.4446 470.285C75.267 471.575 75.113 472.878 74.9946 474.18C74.9946 473.576 74.9236 472.996 74.9118 472.996C74.5684 470.889 72.6503 467.005 70.2705 466.65C69.8757 466.605 69.476 466.644 69.0969 466.763C68.7178 466.881 68.3677 467.078 68.069 467.34C67.7703 467.602 67.5296 467.923 67.3623 468.284C67.195 468.644 67.1047 469.035 67.0974 469.432C67.165 470.293 67.4179 471.13 67.8389 471.884C68.2599 472.638 68.839 473.292 69.5364 473.801C71.1544 474.781 72.9106 475.511 74.746 475.968L74.5921 477.484C74.3908 479.852 74.2014 482.314 73.9409 484.67C73.8462 485.499 73.7278 486.316 73.6094 487.133C73.6094 486.6 73.6094 486.139 73.6094 486.079C73.2542 483.96 71.3361 480.088 68.9681 479.733C68.5726 479.685 68.1715 479.72 67.7908 479.838C67.4101 479.955 67.0585 480.152 66.7589 480.414C66.4594 480.677 66.2187 481 66.0526 481.362C65.8865 481.724 65.7987 482.117 65.795 482.516C65.8511 483.37 66.0919 484.202 66.5007 484.954C66.9096 485.706 67.4767 486.361 68.163 486.873C69.7548 487.865 71.4928 488.6 73.3134 489.051C73.1594 489.88 73.0174 490.721 72.8398 491.514C72.7095 492.059 72.6148 492.591 72.449 493.124C72.2833 493.657 72.1412 494.202 71.9991 494.723C71.6676 495.729 71.3361 496.759 71.0046 497.73C70.7678 498.405 70.531 499.044 70.2942 499.695C70.4007 498.867 70.5665 497.244 70.5546 497.102C70.4679 495.221 69.8969 493.394 68.897 491.798C68.8944 491.588 68.8746 491.378 68.8378 491.171C68.7741 490.778 68.6283 490.403 68.4098 490.07C68.1913 489.737 67.9052 489.455 67.5699 489.24C67.2347 489.025 66.858 488.884 66.4644 488.825C66.0709 488.766 65.6692 488.791 65.2858 488.897C62.9889 489.596 61.6628 493.704 61.6273 495.847C61.6273 495.978 61.7575 497.351 61.8522 498.215C61.722 497.718 61.5918 497.221 61.4497 496.712C61.1774 495.693 60.8577 494.687 60.538 493.61L60.0052 492.047C59.8276 491.514 59.5908 490.981 59.3895 490.448C58.8804 489.205 58.3121 487.974 57.7082 486.754C59.5691 486.295 61.3496 485.557 62.9889 484.564C63.6868 484.06 64.2666 483.411 64.6878 482.66C65.1091 481.91 65.3616 481.077 65.4279 480.219C65.4275 479.82 65.3425 479.426 65.1784 479.062C65.0144 478.699 64.775 478.374 64.4762 478.11C64.1774 477.846 63.8259 477.648 63.445 477.53C63.0641 477.412 62.6625 477.376 62.2666 477.424C59.8986 477.768 57.9569 481.628 57.6017 483.747C57.6017 483.877 57.4951 485.416 57.4596 486.269C57.0926 485.535 56.7374 484.801 56.3348 484.067C55.1508 481.959 53.9668 479.863 52.7828 477.768L51.6817 475.838C52.0014 475.755 55.7665 474.737 57.1518 473.6C57.8519 473.098 58.4339 472.449 58.8573 471.698C59.2806 470.948 59.535 470.114 59.6026 469.255C59.5919 468.861 59.4996 468.473 59.3315 468.116C59.1635 467.76 58.9234 467.442 58.6264 467.183C58.3294 466.924 57.9819 466.729 57.6058 466.61C57.2297 466.492 56.8332 466.453 56.4414 466.496C54.0734 466.839 52.1316 470.711 51.7764 472.819C51.7764 472.984 51.6225 475.187 51.6225 475.767C50.8174 474.346 50.0359 472.937 49.2545 471.504C48.2743 469.59 47.4239 467.612 46.7089 465.584C46.851 465.584 50.7818 464.507 52.2026 463.335C52.9028 462.832 53.4848 462.183 53.9081 461.433C54.3315 460.682 54.5858 459.848 54.6535 458.989C54.6513 458.591 54.565 458.198 54.4003 457.835C54.2356 457.473 53.9963 457.149 53.6979 456.885C53.3995 456.621 53.0488 456.424 52.6687 456.305C52.2886 456.186 51.8877 456.149 51.4922 456.195C49.1242 456.539 47.1825 460.41 46.8273 462.518C46.8273 462.66 46.7089 464.353 46.6852 465.158H46.5431C45.8701 463.087 45.3866 460.959 45.0986 458.8C44.921 457.616 44.8263 456.432 44.7434 455.366C46.6735 455.117 48.5541 454.574 50.3201 453.756C51.0907 453.329 51.7564 452.736 52.2684 452.019C52.7805 451.302 53.1261 450.48 53.2801 449.612C53.3217 449.216 53.2794 448.816 53.156 448.438C53.0325 448.06 52.8307 447.712 52.5636 447.417C52.2966 447.122 51.9704 446.887 51.6062 446.726C51.2421 446.566 50.8482 446.484 50.4503 446.486C48.0823 446.569 45.7143 450.204 45.1105 452.264C45.1105 452.371 44.8855 453.543 44.7553 454.407C44.7553 453.898 44.6842 453.377 44.6724 452.904C44.6132 451.092 44.6724 449.423 44.6724 447.955C44.6724 447.114 44.7671 446.356 44.8263 445.646C46.4435 444.537 47.8777 443.183 49.0769 441.632C49.5494 440.911 49.8588 440.096 49.9836 439.243C50.1083 438.39 50.0454 437.521 49.7991 436.695C49.6508 436.325 49.4266 435.99 49.1411 435.712C48.8556 435.435 48.515 435.22 48.1414 435.081C47.7678 434.943 47.3693 434.884 46.9717 434.909C46.574 434.934 46.1861 435.042 45.8327 435.227C43.7489 436.411 43.3345 440.708 43.7607 442.804C43.7607 442.982 44.7079 445.752 44.7434 445.729C44.6724 446.403 44.6132 447.138 44.554 447.931C44.4593 449.399 44.3646 451.068 44.3882 452.892C44.3843 454.87 44.4989 456.847 44.7316 458.812C44.98 460.994 45.4238 463.15 46.0577 465.253C46.0525 465.276 46.0525 465.3 46.0577 465.324C45.6551 464.744 44.4948 463.169 44.3882 463.051C42.9319 461.488 39.1905 459.309 37.0238 460.327C36.6682 460.506 36.3543 460.758 36.1023 461.066C35.8503 461.375 35.6659 461.732 35.5609 462.116C35.456 462.5 35.4329 462.902 35.4932 463.295C35.5535 463.689 35.6957 464.065 35.9108 464.4C36.4471 465.083 37.1271 465.64 37.9026 466.031C38.6781 466.422 39.5301 466.637 40.3982 466.662Z"
            fill="black"
          />
          <path
            d="M70.9453 509.108H59.9104V525.648H70.9453V509.108Z"
            fill="black"
          />
        </g>
        <path
          d="M523.328 154.902H497.28V167.926H523.328V154.902Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M556.918 154.902H530.87V167.926H556.918V154.902Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M539.774 171.36H513.726V184.384H539.774V171.36Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M539.774 137.071H513.726V150.095H539.774V137.071Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M523.328 203.577H497.28V216.601H523.328V203.577Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M556.918 203.577H530.87V216.601H556.918V203.577Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M556.918 65.1196H530.87V78.1436H556.918V65.1196Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M524.95 107.744H498.902V120.768H524.95V107.744Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M498.464 78.144H472.416V91.168H498.464V78.144Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M480.538 57.8027H454.49V70.8267H480.538V57.8027Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M539.774 220.034H513.726V233.058H539.774V220.034Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M381.118 248.699H355.07V261.723H381.118V248.699Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M414.708 248.699H388.66V261.723H414.708V248.699Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M446.119 265.157H420.071V278.181H446.119V265.157Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M455.662 76.9956H333.343V237.724H455.662V76.9956Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M412.529 76.96H387.44L333.343 131.057V172.615L387.061 118.897L386.659 102.83L412.529 76.96ZM455.662 76.96H454.088L356.869 174.178L376.512 193.809L333.379 236.942V237.723H364.672L416.768 185.627H394.509L379.022 170.141L455.662 93.5004V76.96ZM455.662 110.278L394.272 171.68L411.712 171.869L455.627 215.784V195.774L417.005 157.164L455.627 118.542L455.662 110.278ZM425.056 196.165L383.497 237.723H413.299L439.951 211.06L425.056 196.165ZM333.343 76.96V95.0278L351.376 76.96H333.343Z"
          stroke="#B2B2B2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g opacity="0.3">
          <path
            d="M287.712 56.0508H106.56V287.31H287.712V56.0508Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M280.608 65.1201H113.664V278.24H280.608V65.1201Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M280.608 170.496H113.664V182.336H280.608V170.496Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M273.776 76.3682L239.121 111.012"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M227.458 134.005L222.154 139.31"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M249.729 111.723L233.118 128.346"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M139.404 77.7773L128.44 88.7412"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M242.306 224.534L236.291 230.537"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M265.997 200.842L247.61 219.23"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M273.776 191.216L239.121 225.86"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M227.458 248.854L222.154 254.158"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M249.729 226.57L233.118 243.194"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M139.404 192.625L128.44 203.589"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M242.306 339.382L236.291 345.385"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M265.997 315.69L247.61 334.077"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M482.29 517.692C482.29 517.692 481.106 503.117 482.29 494.213C483.474 485.31 489.169 482.065 489.572 478.016C489.975 473.967 487.547 469.918 489.986 465.868C492.073 462.76 494.517 459.906 497.268 457.367C497.268 457.367 494.036 463.441 496.463 468.295C498.89 473.15 502.655 478.419 500.098 482.503C497.54 486.588 494.841 490.602 495.646 493.846C496.451 497.09 500.915 496.273 500.098 503.555C499.281 510.837 497.268 513.678 497.268 513.678L497.671 517.727L483.912 517.325"
          fill="#00A699"
        />
        <path
          d="M482.29 517.692C482.29 517.692 481.106 503.117 482.29 494.213C483.474 485.31 489.169 482.065 489.572 478.016C489.975 473.967 487.547 469.918 489.986 465.868C492.073 462.76 494.517 459.906 497.268 457.367C497.268 457.367 494.036 463.441 496.463 468.295C498.89 473.15 502.655 478.419 500.098 482.503C497.54 486.588 494.841 490.602 495.646 493.846C496.451 497.09 500.915 496.273 500.098 503.555C499.281 510.837 497.268 513.678 497.268 513.678L497.671 517.727L483.912 517.325"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M481.225 517.526C481.225 517.526 484.102 514.507 479.437 509.948C476.418 507 473.458 502.62 473.316 498.108C473.245 495.871 474.263 494.095 473.576 491.999C472.83 489.714 470.498 488.269 469.859 485.724C468.675 480.81 471.931 476.252 472.333 474.653C472.736 473.055 472.333 472.984 470.143 468.651C468.832 466.157 468.118 463.392 468.059 460.576C468.455 461.987 469.223 463.266 470.283 464.279C471.344 465.291 472.657 466 474.085 466.33C479.177 467.656 482.089 470.924 481.734 477.116C481.379 483.308 480.964 484.86 485.286 485.984C492.059 487.76 491.384 492.413 490.626 498.097C490.14 501.649 489.951 502.584 492.059 505.201C493.775 507.296 496.439 506.941 494.355 510.564C492.059 514.566 495.362 517.94 491.324 518.982C487.287 520.024 481.225 517.526 481.225 517.526Z"
          fill="#00A699"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M498.298 518.201C498.298 518.201 495.504 515.099 500.299 510.671C503.389 507.806 506.468 503.508 506.74 498.973C506.87 496.735 505.911 494.924 506.657 492.863C507.474 490.602 509.842 489.217 510.541 486.695C511.902 481.805 508.753 477.14 508.386 475.553C508.019 473.967 508.386 473.896 510.754 469.633C512.134 467.177 512.92 464.432 513.051 461.618C512.617 463.02 511.813 464.28 510.723 465.263C509.633 466.247 508.298 466.918 506.858 467.206C501.732 468.39 498.736 471.575 498.914 477.767C499.091 483.96 499.47 485.534 495.125 486.541C488.305 488.116 488.838 492.792 489.442 498.499C489.821 502.051 489.986 503.01 487.808 505.52C486.032 507.569 483.392 507.142 485.369 510.825C487.547 514.886 484.185 518.165 488.163 519.314C492.141 520.462 498.298 518.201 498.298 518.201Z"
          fill="#00A699"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M507.107 514.448V535.168C507.111 535.563 507.092 535.959 507.048 536.352C506.961 537.431 506.73 538.495 506.361 539.513C505.463 542.051 503.8 544.249 501.601 545.803C499.402 547.357 496.776 548.192 494.083 548.192H486.979C484.301 548.175 481.693 547.332 479.51 545.779C477.328 544.226 475.677 542.038 474.784 539.513C474.415 538.495 474.184 537.431 474.097 536.352C474.053 535.959 474.034 535.563 474.038 535.168V514.448H507.107Z"
          fill="white"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M507.107 529.248H473.991V530.029H507.107V529.248Z"
          fill="#263238"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M507.048 534.446C506.961 535.525 506.73 536.589 506.361 537.607H474.784C474.415 536.589 474.184 535.525 474.097 534.446H507.048Z"
          fill="#263238"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.0864 201.812L47.0522 345.29"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.9091 324.984L38.2432 317.975"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40.4453 320.272C40.4294 319.101 40.1635 317.947 39.6652 316.887C39.167 315.827 38.4479 314.886 37.5563 314.127C35.6974 312.458 25.9176 308.349 24.9822 311.759C23.9758 315.536 33.9925 322.9 40.4453 320.272Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40.4453 320.272L31.1272 314.458"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M46.5667 340.802L40.0547 335.392"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.2568 337.689C42.2481 336.514 41.9867 335.355 41.4902 334.291C40.9938 333.227 40.2739 332.281 39.3797 331.52C37.5208 329.851 27.7291 325.742 26.8056 329.152C25.7874 332.953 35.804 340.317 42.2568 337.689Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.2568 337.688L32.9387 331.875"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40.3863 281.401L33.8032 275.481"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36.0054 277.778C35.9962 276.61 35.7368 275.457 35.2446 274.397C34.7524 273.337 34.0388 272.394 33.1519 271.633C31.293 269.964 21.5014 265.855 20.5778 269.265C19.5359 273.042 29.5999 280.407 36.0054 277.778Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36.0053 277.778L26.6873 271.965"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.2213 299.919L35.6265 292.898"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37.8879 295.195C37.8721 294.024 37.6061 292.87 37.1079 291.81C36.6096 290.75 35.8906 289.809 34.999 289.05C33.1401 287.38 23.3602 283.272 22.4249 286.682C21.3119 290.459 31.3759 297.823 37.8879 295.195Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37.8288 295.195L28.5107 289.381"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37.4499 253.92L30.855 247.195"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33.0572 249.492C33.0413 248.321 32.7754 247.167 32.2771 246.107C31.7788 245.048 31.0598 244.106 30.1682 243.347C28.3093 241.678 18.5295 237.569 17.5941 240.979C16.5759 244.756 26.6044 252.121 33.0572 249.492Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33.0571 249.492L23.739 243.679"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34.2767 223.669L27.8831 218.779"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.0854 221.076C30.0762 219.907 29.8168 218.754 29.3246 217.694C28.8324 216.634 28.1188 215.692 27.2319 214.931C25.373 213.274 15.5814 209.153 14.6578 212.563C13.6278 216.352 23.6799 223.705 30.0854 221.076Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.0853 221.076L20.7791 215.275"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.2698 315.322L49.7754 306.336"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M48.0939 309.024C47.867 307.876 47.888 306.692 48.1555 305.553C48.423 304.413 48.9308 303.344 49.6449 302.417C51.1249 300.416 59.851 294.366 61.4849 297.539C63.2372 301.008 54.9492 310.291 48.0939 309.024Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M48.094 309.036L54.6534 302.891"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M39.4863 269.502L44.9919 260.515"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M43.3107 263.215C43.0838 262.066 43.1048 260.883 43.3723 259.744C43.6398 258.604 44.1476 257.535 44.8617 256.608C46.3417 254.595 53.1497 249.563 54.7836 252.748C56.5478 256.205 50.166 264.458 43.3107 263.215Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M43.3105 263.215L51.7051 255.199"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37.3789 249.362L42.8963 240.375"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M41.215 243.075C40.9881 241.927 41.0091 240.743 41.2766 239.604C41.5441 238.465 42.0519 237.395 42.766 236.468C44.246 234.455 52.9602 228.405 54.606 231.59C56.3465 235.047 48.0703 244.318 41.215 243.075Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M41.2148 243.075L49.5976 235.06"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34.3003 219.833L39.8059 210.858"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38.1248 213.546C37.898 212.397 37.9202 211.213 38.1898 210.073C38.4594 208.934 38.9702 207.865 39.6877 206.94C41.1559 204.939 49.882 198.888 51.5277 202.061C53.28 205.531 44.992 214.801 38.1248 213.546Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38.1248 213.546L46.5193 205.53"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M31.9679 200.96C31.741 199.812 31.762 198.629 32.0295 197.489C32.297 196.35 32.8048 195.281 33.5189 194.353C34.9989 192.341 43.725 186.29 45.3589 189.475C47.0876 192.992 38.7996 202.203 31.9679 200.96Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M31.9443 200.96L40.3389 192.944"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.4297 201.28C31.2696 201.386 30.1002 201.244 28.9996 200.862C27.8991 200.48 26.8927 199.868 26.0479 199.066C24.2009 197.396 19.1097 188.078 22.4367 186.8C26.0479 185.414 34.3951 194.614 32.4297 201.28Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.4296 201.303L25.3374 192.127"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.0149 160.539V344.935"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.2248 222.9L61.4968 345.645"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M61.6981 344.745L58.0159 340.542"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M58.0159 340.542C58.2498 339.387 58.2324 338.194 57.9648 337.046C57.6971 335.898 57.1856 334.821 56.4648 333.888C54.9848 331.875 46.2588 325.837 44.6248 329.01C42.8725 332.526 51.1605 341.785 58.0159 340.542Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M58.0159 340.542L50.095 332.94"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M66.1855 301.02L60.7273 296.461"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M62.4322 298.048C62.659 296.899 62.6369 295.715 62.3673 294.575C62.0977 293.436 61.5869 292.367 60.8693 291.441C59.4012 289.429 50.6633 283.378 49.0293 286.563C47.2889 290.08 55.5769 299.291 62.4322 298.048Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M62.4322 298.048L54.5112 290.447"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64.4569 321.74L58.9395 312.765"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.6206 315.453C60.8475 314.305 60.8265 313.121 60.559 311.982C60.2915 310.842 59.7837 309.773 59.0696 308.846C57.5896 306.845 48.8635 300.795 47.2296 303.98C45.4773 307.437 53.7653 316.708 60.6206 315.453Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.6207 315.453L52.6997 307.863"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68.9442 273.125L63.6873 267.051"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65.3685 269.751C65.5953 268.602 65.5732 267.418 65.3036 266.278C65.034 265.138 64.5232 264.07 63.8056 263.144C62.3256 261.143 53.5995 255.093 51.9656 258.278C50.2251 261.735 58.5131 271.006 65.3685 269.751Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65.3685 269.751L57.4475 262.149"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M71.7149 246.532L66.6355 238.647"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68.3167 241.335C68.5435 240.186 68.5214 239.002 68.2518 237.862C67.9822 236.722 67.4714 235.654 66.7539 234.728C65.2739 232.727 56.5478 226.677 54.9139 229.862C53.1734 233.319 61.4614 242.59 68.3167 241.335Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68.3167 241.335L60.3958 233.745"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M62.7756 336.493L70.0217 328.832"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M67.8193 331.129C67.8382 329.96 68.1044 328.808 68.6002 327.749C69.0961 326.69 69.8105 325.748 70.6965 324.984C72.5553 323.315 82.347 319.194 83.2705 322.616C84.2888 326.393 74.2721 333.758 67.8193 331.129Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M67.8193 331.129L77.6821 325.008"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M67.5352 290.66L74.7812 283"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M72.5791 285.344C72.5912 284.173 72.8543 283.019 73.3506 281.959C73.8469 280.899 74.565 279.958 75.4562 279.199C77.3151 277.541 87.0949 273.409 88.0303 276.831C89.0367 280.608 79.0319 287.925 72.5791 285.344Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M72.5791 285.297L82.4418 279.175"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M69.6309 270.52L76.8651 262.86"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.6628 265.216C74.6787 264.045 74.9446 262.891 75.4429 261.831C75.9411 260.771 76.6602 259.83 77.5518 259.071C79.4107 257.413 89.1905 253.281 90.114 256.703C91.1678 260.48 81.1156 267.785 74.6628 265.216Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.6628 265.156L84.5256 259.035"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M72.6028 239.488L79.9317 233.343"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M77.7295 235.616C77.7423 234.445 78.0058 233.291 78.5021 232.231C78.9983 231.171 79.716 230.23 80.6066 229.471C82.4655 227.813 92.2572 223.693 93.1807 227.103C94.1989 230.88 84.1823 238.268 77.7295 235.616Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M77.7295 235.627L87.5922 229.518"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.2722 222.036C74.2843 220.865 74.5474 219.711 75.0437 218.651C75.5401 217.591 76.2581 216.649 77.1493 215.891C79.0082 214.233 88.7881 210.113 89.7234 213.523C90.7417 217.3 80.725 224.664 74.2722 222.036Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.2722 222.035L84.1349 215.914"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.6747 222.473C73.5076 222.333 72.3844 221.943 71.3813 221.33C70.3782 220.717 69.5188 219.896 68.8613 218.921C67.405 216.897 64.3384 206.738 67.8549 206.17C71.691 205.601 77.9662 216.34 74.6747 222.473Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.6748 222.474L69.6191 212.031"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.7545 324.712L49.7634 316.708"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7171 319.218C51.8242 318.051 51.6798 316.874 51.2938 315.767C50.9078 314.66 50.2891 313.648 49.4793 312.801C47.8099 310.966 38.5036 305.851 37.2249 309.178C35.8278 312.801 44.9919 321.172 51.7171 319.218Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7169 319.218L43.05 312.469"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.9676 286.09L49.7634 280.312"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7171 282.822C51.824 281.656 51.6795 280.481 51.2935 279.376C50.9075 278.271 50.2888 277.262 49.4793 276.417C47.8099 274.569 38.5036 269.455 37.2249 272.793C35.8278 276.417 44.9919 284.776 51.7171 282.822Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7169 282.822L43.05 276.085"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.1689 245.952L49.7634 237.593"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7171 240.103C51.8242 238.936 51.6798 237.759 51.2938 236.652C50.9078 235.545 50.2891 234.534 49.4793 233.686C47.8099 231.851 38.5036 226.736 37.2249 230.063C35.8278 233.686 44.9919 242.057 51.7171 240.103Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7169 240.103L43.05 233.354"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.7545 214.552L49.7634 209.153"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7171 211.663C51.8242 210.496 51.6798 209.319 51.2938 208.212C50.9078 207.105 50.2891 206.094 49.4793 205.246C47.8099 203.399 38.5036 198.296 37.2249 201.623C35.8278 205.246 44.9919 213.605 51.7171 211.663Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7169 211.663L43.05 204.915"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.0978 186.101L49.8818 181.542"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7171 183.094C51.824 181.928 51.6795 180.753 51.2935 179.648C50.9075 178.543 50.2888 177.534 49.4793 176.688C47.8099 174.841 38.5036 169.726 37.2249 173.054C35.8278 176.688 44.9919 185.047 51.7171 183.094Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51.7169 183.093L43.05 176.356"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M57.27 334.385L62.4441 327.826"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 330.336C60.3865 329.167 60.5346 327.989 60.9247 326.882C61.3148 325.775 61.9379 324.764 62.752 323.918C64.4332 322.071 73.7395 316.957 75.0182 320.295C76.3798 323.918 67.1801 332.278 60.4905 330.336Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 330.324L69.6665 323.22"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.0269 278.311L62.4441 269.94"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 272.45C60.3883 271.283 60.5372 270.107 60.9273 269.002C61.3173 267.897 61.9395 266.889 62.752 266.044C64.4333 264.197 73.7395 259.083 75.0182 262.421C76.3798 266.044 67.1801 274.403 60.4905 272.45Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 272.45L69.6665 265.346"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.0269 249.741L62.4441 241.382"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 243.904C60.3848 242.733 60.532 241.553 60.9222 240.443C61.3123 239.334 61.9364 238.322 62.752 237.475C64.4332 235.628 73.7395 230.525 75.0182 233.852C76.3798 237.475 67.1801 245.834 60.4905 243.904Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 243.88L69.6665 236.776"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.0269 211.983L62.4441 203.624"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 206.134C60.3919 204.965 60.5425 203.789 60.9323 202.683C61.3222 201.576 61.9424 200.566 62.752 199.717C64.4332 197.87 73.7395 192.767 75.0182 196.094C76.3798 199.717 67.1801 208.076 60.4905 206.134Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 206.134L69.6665 199.03"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.311 179.399L62.5981 174.498"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4904 176.416C60.3916 175.253 60.5422 174.081 60.9322 172.981C61.3221 171.88 61.9425 170.876 62.7518 170.034C64.4331 168.187 73.7393 163.084 75.0181 166.411C76.3797 170.034 67.18 178.393 60.4904 176.416Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60.4905 176.439L69.6665 169.335"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.648 163.285C55.5448 162.119 55.6897 160.944 56.0734 159.838C56.4571 158.732 57.0707 157.72 57.874 156.868C59.5552 155.021 68.8615 149.918 70.1402 153.245C71.5373 156.868 62.3376 165.227 55.648 163.285Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.6479 163.285L64.8239 156.181"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.0978 163.676C54.9269 163.66 53.7728 163.394 52.713 162.896C51.6532 162.398 50.7121 161.679 49.9529 160.787C48.2953 158.928 44.1868 149.136 47.5849 148.213C51.3855 147.207 58.7382 157.223 56.0978 163.676Z"
          fill="#00A699"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.0977 163.676L49.9883 153.801"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M487.583 222.497C487.583 222.497 459.83 235.758 454.431 243.809C452.063 247.302 436.268 310.421 436.268 310.421L425.802 319.147L441.845 347.563H537.121C537.121 347.563 544.095 249.291 542.698 244.437C541.301 239.582 508.173 225.291 504.384 223.539C500.595 221.787 490.732 220.745 487.583 222.497Z"
          fill="#FF5A5F"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M474.973 293.999L492.686 308.621L478.667 300.712"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M467.881 288.138L472.167 291.678"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M374.203 331.52C374.203 331.52 370.912 332.017 369.597 334.149C368.283 336.28 365.809 342.377 366.957 342.875C368.106 343.372 368.934 341.56 369.763 340.246C370.592 338.932 371.729 336.955 371.729 336.955L374.369 336.457L374.203 331.52Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M378.809 328.347C378.809 328.347 375.02 328.015 374.073 329.661C373.126 331.307 371.113 342.164 371.279 343.49C371.444 344.816 373.09 345.455 374.404 343.158C375.719 340.862 378.513 330.655 378.513 330.655L378.809 328.347Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M386.54 328.181C386.54 328.181 380.952 325.553 378.643 326.05C376.334 326.547 373.055 343.324 373.54 344.141C373.793 344.372 374.091 344.548 374.416 344.657C374.74 344.766 375.084 344.806 375.425 344.775C375.766 344.744 376.096 344.642 376.396 344.476C376.695 344.309 376.956 344.083 377.163 343.81C377.98 342.496 382.752 334.433 384.078 332.467C384.975 331.084 385.797 329.653 386.54 328.181Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M444 336.789C444 336.789 441.857 322.202 437.95 316.519C434.042 310.836 431.153 315.726 425.245 318.804C421.693 320.675 400.239 329.673 399.197 330.028C398.155 330.384 388.885 325.044 387.109 326.476C385.333 327.909 378.572 336.434 377.151 341.051C375.73 345.669 379.282 346.036 380.703 344.603C382.124 343.171 386.398 336.422 388.174 335.001C389.95 333.58 394.224 338.198 394.224 338.198C394.224 338.198 387.819 341.395 385.688 342.827C383.557 344.26 386.753 344.959 390.305 344.959C393.872 344.809 397.375 343.964 400.618 342.472L404.17 340.684C404.17 340.684 432.219 340.696 444 336.789Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M489.679 130.37C489.679 130.37 462.115 142.21 459.664 150.261C457.213 158.313 462.459 159.331 463.157 163.522C463.856 167.714 444.663 187.202 452.347 199.469C460.031 211.735 501.898 214.861 519.338 211.676C536.778 208.491 547.955 196.284 546.913 182.36C545.871 168.436 537.441 161.77 527.022 146.07C516.603 130.37 497.008 127.931 489.679 130.37Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M469.787 180.619C469.787 180.619 465.253 180.974 465.253 184.455C465.253 187.936 469.787 195.277 471.883 194.922C473.979 194.567 469.787 180.619 469.787 180.619Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M484.445 150.262C484.445 150.262 468.39 161.427 468.746 167.714C469.101 174.001 468.047 189.689 473.28 200.167C476.978 207.314 481.175 214.191 485.843 220.745C485.843 220.745 482.705 247.977 483.048 254.951C483.392 261.925 488.968 258.444 495.267 250.76C501.566 243.075 507.829 225.99 507.829 225.99L503.993 221.408L504.692 215.832C504.692 215.832 513.063 208.503 515.502 202.216C516.828 198.829 516.555 191.406 516.555 191.406C517.922 190.823 519.154 189.963 520.173 188.881C521.192 187.799 521.976 186.518 522.475 185.119L523.873 180.584C520.747 179.017 517.714 177.27 514.791 175.351C511.122 172.399 507.627 169.236 504.325 165.879C504.325 165.879 490.034 158.656 484.445 150.262Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M483.747 175.729C483.747 175.729 482.006 193.489 484.102 197.373C486.198 201.257 491.774 197.373 491.774 197.373"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M485.44 204.702C485.44 204.702 494.521 206.442 499.399 200.167"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M496.309 179.921C497.466 179.921 498.405 178.749 498.405 177.304C498.405 175.859 497.466 174.688 496.309 174.688C495.152 174.688 494.213 175.859 494.213 177.304C494.213 178.749 495.152 179.921 496.309 179.921Z"
          fill="#263238"
        />
        <path
          d="M476.773 179.921C477.931 179.921 478.869 178.749 478.869 177.304C478.869 175.859 477.931 174.688 476.773 174.688C475.616 174.688 474.677 175.859 474.677 177.304C474.677 178.749 475.616 179.921 476.773 179.921Z"
          fill="#263238"
        />
        <path
          d="M492.473 167.714C492.473 167.714 497.706 165.618 500.844 168.756"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M480.609 168.057C480.609 168.057 475.376 165.618 473.28 170.496"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M454.549 282.1L458.895 305.129L450.003 338.565"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M452.856 273.113L453.578 276.973"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M534.351 237.854C534.351 237.854 545.291 242.969 544.687 246.509C544.084 250.049 547.304 328.11 543.503 333.486C539.703 338.861 529.118 337.038 529.118 337.038C529.118 337.038 524.619 323.031 520.025 318.792C515.431 314.554 513.75 315.998 513.75 315.998L516.887 268.531"
          fill="#FF5A5F"
        />
        <path
          d="M534.351 237.854C534.351 237.854 545.291 242.969 544.687 246.509C544.084 250.049 547.304 328.11 543.503 333.486C539.703 338.861 529.118 337.038 529.118 337.038C529.118 337.038 524.619 323.031 520.025 318.792C515.431 314.554 513.75 315.998 513.75 315.998L516.887 268.531"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M432.503 332.491C430.936 334.402 429.069 336.046 426.974 337.357C423.73 339.311 419.503 340.281 422.427 341.584C425.352 342.886 429.898 340.933 432.503 339.311C435.108 337.688 432.503 332.491 432.503 332.491Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M497.671 326.002C504.775 321.669 511.145 314.458 519.989 314.162C528.834 313.866 536.98 320.083 540.887 327.565C542.165 330.016 543.054 332.893 542.248 335.534C540.745 340.507 534.529 341.951 529.378 342.555L500.962 345.929C483.936 347.942 466.011 349.836 450.216 343.159C450.01 344.667 449.339 346.074 448.298 347.184C447.114 348.167 445.018 348.12 444.426 346.734C443.809 347.313 443.015 347.665 442.172 347.734C441.329 347.803 440.488 347.584 439.785 347.113C439.489 346.936 437.973 347.717 436.399 347.445C435.842 347.338 433.901 346.486 433.344 346.355C432.973 346.312 432.615 346.196 432.29 346.013C431.965 345.83 431.679 345.584 431.45 345.29C431.219 344.82 431.121 344.296 431.166 343.774C430.968 340.422 431.288 337.06 432.113 333.805C436.115 320.97 450.441 328.003 458.054 333.047C460.647 334.764 463.382 336.528 466.472 336.824C468.789 336.895 471.1 336.546 473.292 335.794C481.474 333.509 490.105 330.632 497.588 326.121L497.671 326.002Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M450.168 343.123L451.4 338.292"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M444.521 346.131C444.521 346.131 445.172 332.811 447.445 329.886"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M439.974 346.45C439.974 346.45 438.992 334.764 441.265 329.235"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M435.049 346.403C435.049 346.403 434.125 337.464 435.747 331.188"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M41.6768 347.764L32.7968 264.517C32.7302 263.901 32.7942 263.278 32.9848 262.689C33.1754 262.099 33.4881 261.557 33.9027 261.096C34.3172 260.636 34.8243 260.268 35.3906 260.017C35.957 259.766 36.5699 259.637 37.1894 259.639H94.5779C95.5829 259.637 96.5583 259.979 97.3423 260.608C98.1262 261.237 98.6715 262.115 98.8877 263.096L117.642 347.764H41.6768Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M111.852 206.584C111.852 206.584 75.6576 225.836 74.6631 233.473C73.6685 241.109 70.6848 347.634 70.6848 347.634H165.63C165.63 347.634 156.335 305.851 155.341 300.866C154.346 295.881 152.973 287.262 152.973 287.262L184.254 301.47L188.895 270.271C188.895 270.271 172.556 246.745 162.267 233.792C151.978 220.839 138.694 210.882 132.667 209.556C126.641 208.23 111.852 206.584 111.852 206.584Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M153.02 287.262L154.808 272.036L159.828 254.276"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M154.808 272.036L155.814 256.289"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M143.714 294.141C144.566 294.484 145.371 294.828 146.082 295.171"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M111.225 284.775C111.225 284.775 128.026 288.635 139.641 292.613"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M131.673 246.568C131.673 246.568 133.354 273.042 134.041 274.723C134.727 276.405 138.398 275.055 138.398 275.055L136.03 259.663"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M102.001 262.22L104.523 258.633"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M91.7837 276.736L99.4679 265.82"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M122.733 198.912C122.733 198.912 112.077 201.28 110.124 203.222C108.17 205.164 104.808 217.501 104.808 217.501L110.728 248.711C110.728 248.711 127.659 233.769 129.979 233.106C132.3 232.443 152.227 244.058 152.227 244.058C152.227 244.058 151.564 228.453 146.579 218.495C141.595 208.538 137.285 204.56 132.643 201.564C129.659 199.757 126.222 198.837 122.733 198.912Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M122.733 177.363C122.733 177.363 120.365 194.626 119.75 200.274C119.134 205.921 115.771 203.257 117.761 210.231C119.75 217.205 130.702 245.751 133.034 243.383C135.367 241.015 142.66 212.848 144.318 210.847C145.975 208.846 148.971 204.927 148.971 204.927L122.733 177.363Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M122.52 178.95C122.07 182.336 120.993 190.411 120.271 196.059L145.632 205.021L143.596 199.315L124.971 179.743L122.52 178.95Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M83.9573 224.178C83.9573 224.178 71.3477 231.152 71.0162 234.834C70.6847 238.516 47.4428 320.13 49.7279 326.428C52.013 332.727 63.0124 333.734 63.0124 333.734C63.0124 333.734 73.3013 316.803 78.949 313.819C81.4235 312.446 83.9866 311.24 86.6213 310.208L98.5679 253.376"
          fill="white"
        />
        <path
          d="M83.9573 224.178C83.9573 224.178 71.3477 231.152 71.0162 234.834C70.6847 238.516 47.4428 320.13 49.7279 326.428C52.013 332.727 63.0124 333.734 63.0124 333.734C63.0124 333.734 73.3013 316.803 78.949 313.819C81.4235 312.446 83.9866 311.24 86.6213 310.208L98.5679 253.376"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M165.961 329.424C167.562 331.377 169.47 333.056 171.609 334.397C174.924 336.398 179.246 337.393 176.262 338.719C173.278 340.045 168.625 338.056 165.961 336.351C163.297 334.646 165.961 329.424 165.961 329.424Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M92.9203 316.128C92.9203 316.128 92.7308 315.879 92.3756 315.465C90.3839 313.064 87.9779 311.038 85.2716 309.486C81.2816 307.497 69.335 307.118 59.0342 319.124C48.7334 331.129 54.0614 337.049 62.3612 339.039C70.6611 341.028 101.871 342.685 109.496 344.023C117.121 345.361 131.412 346.391 136.728 344.023C140.301 342.489 143.958 341.157 147.68 340.033C147.68 340.033 149.338 345.349 151.67 345.349C154.003 345.349 153.683 343.36 153.683 343.36C153.683 343.36 155.009 344.698 156.051 344.698C156.912 344.574 157.728 344.231 158.419 343.703C158.937 344.088 159.536 344.348 160.171 344.463C160.805 344.578 161.458 344.545 162.078 344.367C164.067 343.703 164.067 342.697 164.067 342.697C164.067 342.697 166.435 344.698 167.394 342.697C168.353 340.696 166.719 334.066 166.056 329.424C165.393 324.783 162.078 324.771 162.078 324.771L161.059 324.049C160.55 323.689 159.97 323.441 159.357 323.323C158.745 323.205 158.114 323.218 157.507 323.362L155.803 323.777C155.803 323.777 152.487 323.114 150.818 323.777C149.148 324.44 135.225 332.74 133.224 333.734C131.223 334.729 125.918 333.734 119.951 331.366C113.984 328.998 95.904 321.125 92.9203 316.128Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M147.704 340.045L146.65 335.356"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68.3523 328.43C75.6576 318.496 92.9203 316.128 92.9203 316.128C92.9203 316.128 92.7308 315.879 92.3756 315.465C90.3839 313.064 87.9779 311.038 85.2716 309.486C81.2816 307.497 69.335 307.118 59.0342 319.124C48.7334 331.129 54.0614 337.049 62.3612 339.039C63.2966 339.263 64.5516 339.488 66.0198 339.702C65.12 336.753 65.12 332.846 68.3523 328.43Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M153.683 343.36C153.683 343.36 153.02 329.756 150.688 326.784"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M158.324 343.703C158.324 343.703 159.331 331.745 156.998 326.097"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M163.972 342.697C164.132 337.795 163.687 332.891 162.646 328.098"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M188.907 270.26C188.907 270.26 185.355 265.595 183.082 267.892C180.809 270.189 177.718 290.033 177.718 296.095C177.718 302.157 176.783 301.92 184.005 303.317C191.228 304.714 193.797 305.188 196.603 303.791C199.409 302.393 195.419 293.525 193.335 286.303C191.251 279.081 188.907 270.26 188.907 270.26Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M198.142 169.49C199.116 169.281 200.127 169.326 201.079 169.62L198.142 169.49Z"
          fill="white"
        />
        <path
          d="M198.142 169.49C199.116 169.281 200.127 169.326 201.079 169.62"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M183.863 189.688C184.725 188.91 185.517 188.058 186.231 187.143C188.872 183.839 191.05 174.438 195.49 170.815"
          fill="white"
        />
        <path
          d="M183.863 189.688C184.725 188.91 185.517 188.058 186.231 187.143C188.872 183.839 191.05 174.438 195.49 170.815"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M180.998 188.102C180.998 188.102 184.55 186.267 185.545 179.814L180.998 188.102Z"
          fill="white"
        />
        <path
          d="M180.998 188.102C180.998 188.102 184.55 186.267 185.545 179.814"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M194.733 220.603L192.163 236.444C192.163 236.444 213.617 281.211 213.854 289.606C214.091 298.001 211.486 302.891 202.192 303.814C192.897 304.738 190.541 302.63 188.209 293.324C185.876 284.018 184.242 237.368 184.242 237.368C184.242 237.368 179.814 231.306 178.642 229.21C177.725 227.31 177.174 225.253 177.02 223.148C177.02 222.45 175.386 202.866 175.386 202.866L192.163 202.629L194.733 220.603Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M193.43 218.613L184.834 219.88C184.575 219.935 184.308 219.938 184.048 219.889C183.787 219.839 183.54 219.738 183.319 219.591C183.099 219.444 182.909 219.255 182.763 219.034C182.617 218.814 182.516 218.566 182.466 218.306L182.04 216.151C181.985 215.892 181.982 215.624 182.032 215.364C182.082 215.104 182.183 214.856 182.329 214.636C182.476 214.415 182.665 214.226 182.886 214.079C183.107 213.933 183.355 213.832 183.615 213.783L192.211 212.528C192.469 212.471 192.736 212.466 192.996 212.515C193.256 212.563 193.504 212.663 193.725 212.808C193.946 212.954 194.135 213.143 194.282 213.363C194.428 213.583 194.529 213.831 194.579 214.091L195.005 216.245C195.058 216.504 195.06 216.771 195.01 217.031C194.959 217.291 194.858 217.538 194.711 217.758C194.565 217.978 194.376 218.167 194.156 218.314C193.937 218.461 193.69 218.563 193.43 218.613Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M194.531 223.137L188.292 224.06C188.102 224.098 187.906 224.096 187.716 224.057C187.527 224.017 187.347 223.94 187.188 223.829C187.029 223.719 186.894 223.578 186.791 223.414C186.687 223.25 186.618 223.067 186.587 222.876L186.279 221.313C186.243 221.124 186.245 220.93 186.286 220.742C186.326 220.553 186.404 220.375 186.514 220.217C186.625 220.06 186.765 219.926 186.928 219.823C187.091 219.72 187.273 219.651 187.463 219.62L193.702 218.697C194.086 218.628 194.48 218.714 194.8 218.936C195.12 219.158 195.338 219.498 195.407 219.881L195.715 221.443C195.751 221.633 195.748 221.827 195.708 222.015C195.668 222.203 195.59 222.381 195.48 222.539C195.369 222.697 195.229 222.831 195.066 222.934C194.903 223.036 194.721 223.105 194.531 223.137Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M193.572 205.672L184.479 207.01C183.931 207.118 183.363 207.004 182.899 206.694C182.435 206.383 182.113 205.901 182.004 205.353L181.566 203.068C181.513 202.797 181.514 202.519 181.568 202.248C181.623 201.978 181.73 201.721 181.884 201.492C182.038 201.263 182.236 201.067 182.466 200.915C182.696 200.763 182.953 200.657 183.224 200.605L192.317 199.267C192.863 199.163 193.429 199.278 193.89 199.589C194.351 199.899 194.671 200.379 194.78 200.925L195.23 203.21C195.283 203.48 195.283 203.759 195.228 204.029C195.174 204.299 195.066 204.556 194.912 204.785C194.758 205.014 194.561 205.21 194.331 205.362C194.101 205.515 193.843 205.62 193.572 205.672Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M194.496 212.433L185.403 213.771C185.132 213.824 184.854 213.824 184.583 213.769C184.313 213.715 184.056 213.607 183.827 213.453C183.598 213.299 183.402 213.102 183.25 212.872C183.098 212.642 182.992 212.384 182.94 212.113L182.49 209.828C182.437 209.558 182.437 209.279 182.492 209.009C182.546 208.738 182.654 208.481 182.808 208.253C182.962 208.024 183.159 207.828 183.389 207.675C183.619 207.523 183.877 207.418 184.148 207.365L193.241 206.027C193.788 205.923 194.355 206.038 194.818 206.348C195.281 206.659 195.604 207.139 195.715 207.685L196.153 209.97C196.208 210.241 196.209 210.52 196.155 210.791C196.101 211.062 195.994 211.319 195.84 211.548C195.686 211.778 195.487 211.974 195.257 212.126C195.026 212.277 194.767 212.382 194.496 212.433Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M119.904 168.223C119.904 168.223 117.394 143.027 114.363 134.455C111.332 125.883 122.426 116.316 148.628 116.825C174.829 117.334 184.408 128.914 184.905 134.455C185.403 139.996 178.855 144.033 178.855 144.033L176.345 151.137L153.162 145.596C153.162 145.596 153.162 151.635 151.149 154.157C149.137 156.679 137.545 160.704 137.545 160.704C137.545 160.704 135.023 169.774 130.998 174.308C126.972 178.843 120.91 178.346 120.413 175.327C120.08 172.973 119.91 170.599 119.904 168.223Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M125.954 172.757C125.954 172.757 127.469 162.682 119.406 162.682C111.343 162.682 113.356 172.757 115.854 177.789C118.353 182.821 121.396 183.84 121.396 183.84C121.396 183.84 137.013 204.5 142.554 207.52C148.095 210.539 151.126 212.564 155.151 210.539C159.177 208.514 171.277 193.418 173.29 185.355C174.469 180.91 175.148 176.347 175.315 171.751C175.315 171.751 179.85 162.172 179.85 157.638C179.85 153.103 178.831 144.034 178.831 144.034C178.831 144.034 156.667 135.971 150.119 137.486C143.572 139.002 140.541 138.492 143.56 141.038C146.579 143.584 148.095 151.114 146.082 152.12C144.069 153.127 131.981 153.127 131.981 157.661C131.981 162.196 133.484 164.765 131.471 167.24C129.771 169.213 127.927 171.057 125.954 172.757Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M158.893 188.919C158.893 188.919 165.867 189.914 167.181 188.256C168.495 186.598 168.187 173.977 168.187 173.977L173.16 167.003C173.16 167.003 176.156 165.014 177.482 167.003"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M156.572 199.539L161.225 197.882"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M154.867 171.585C154.394 173.361 153.162 174.592 152.108 174.308C151.055 174.024 150.605 172.367 151.078 170.579C151.552 168.791 152.783 167.571 153.825 167.844C154.867 168.116 155.341 169.797 154.867 171.585Z"
          fill="#263238"
        />
        <path
          d="M173.74 174.486C173.267 176.274 172.035 177.493 170.993 177.209C169.951 176.925 169.478 175.267 169.951 173.48C170.425 171.692 171.656 170.472 172.698 170.745C173.74 171.017 174.214 172.698 173.74 174.486Z"
          fill="#263238"
        />
        <path
          d="M150.261 162.694C150.261 162.694 155.246 159.367 162.551 163.688"
          stroke="#263238"
          stroke-miterlimit="10"
        />
        <path
          d="M160.574 194.176L165.937 229.033L184.372 227.695L185.379 192.495C185.379 192.495 177.671 189.843 160.574 194.176Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M411.345 480.266L425.494 540.176C425.601 540.598 425.609 541.04 425.519 541.466C425.429 541.892 425.242 542.291 424.974 542.634C424.705 542.977 424.362 543.254 423.97 543.444C423.577 543.633 423.147 543.731 422.712 543.728H404.857V548.192H427.424C428.235 548.193 429.035 548.008 429.764 547.651C430.492 547.294 431.129 546.775 431.625 546.133C432.121 545.492 432.464 544.745 432.626 543.95C432.789 543.156 432.767 542.334 432.563 541.55L414.803 473.766L411.345 480.266Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M425.68 415.299L417.848 413.94L398.658 524.565L406.49 525.924L425.68 415.299Z"
          fill="#FC642D"
        />
        <path
          d="M378.75 545.078H306.538V548.204H378.75V545.078Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M477.341 343.774H335.913V347.824H477.341V343.774Z"
          fill="#263238"
          stroke="#FC642D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M477.329 343.774H427.684V347.824H477.329V343.774Z"
          fill="white"
          stroke="#FC642D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M429.366 343.774H337.535L328.607 282.704C328.483 282.051 328.507 281.379 328.676 280.737C328.846 280.095 329.158 279.5 329.589 278.994C330.019 278.489 330.558 278.086 331.164 277.816C331.771 277.546 332.431 277.416 333.095 277.435H414.4C415.859 277.481 417.257 278.031 418.355 278.991C419.454 279.952 420.186 281.264 420.426 282.704L429.366 343.774Z"
          fill="white"
          stroke="#FC642D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M427.602 343.774H335.77L326.843 282.704C326.719 282.05 326.743 281.377 326.913 280.734C327.084 280.091 327.396 279.495 327.828 278.989C328.26 278.484 328.8 278.081 329.408 277.812C330.017 277.543 330.678 277.414 331.342 277.435H412.636C414.096 277.48 415.495 278.03 416.596 278.99C417.697 279.951 418.431 281.263 418.674 282.704L427.602 343.774Z"
          fill="white"
          stroke="#FC642D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M142.021 347.823H286.563V343.691H142.021V347.823Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M142.033 347.823H192.767V343.691H142.033V347.823Z"
          fill="#FC642D"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M191.062 343.691H284.906L294.034 281.271C294.16 280.603 294.135 279.916 293.961 279.26C293.786 278.604 293.467 277.995 293.026 277.478C292.586 276.962 292.035 276.55 291.414 276.274C290.794 275.998 290.119 275.865 289.441 275.884H206.359C204.867 275.929 203.436 276.491 202.311 277.473C201.186 278.456 200.437 279.798 200.191 281.271L191.062 343.691Z"
          fill="#FC642D"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M192.862 343.691H286.706L295.834 281.271C295.962 280.605 295.938 279.918 295.766 279.262C295.594 278.606 295.277 277.997 294.839 277.48C294.401 276.962 293.852 276.549 293.234 276.271C292.615 275.993 291.942 275.856 291.264 275.872H208.159C206.666 275.917 205.235 276.479 204.111 277.461C202.986 278.444 202.236 279.786 201.99 281.259L192.862 343.691Z"
          fill="#FC642D"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M242.542 307.84C242.813 306.229 243.631 304.761 244.859 303.682C246.086 302.604 247.647 301.981 249.279 301.92C250.026 301.895 250.768 302.039 251.451 302.341C252.135 302.643 252.741 303.096 253.224 303.665C253.708 304.234 254.057 304.905 254.245 305.628C254.434 306.351 254.456 307.107 254.311 307.84C254.04 309.453 253.22 310.922 251.991 312.001C250.761 313.079 249.197 313.701 247.562 313.76C246.818 313.781 246.078 313.634 245.397 313.33C244.717 313.026 244.113 312.573 243.631 312.005C243.149 311.437 242.801 310.767 242.613 310.046C242.424 309.325 242.4 308.571 242.542 307.84Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.6001 548.204H582.197"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M570.368 347.824H319.218"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M304.264 347.824H26.8057"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M224.853 362.304C224.853 362.304 222.734 341.939 212.09 335.557C201.446 329.176 206.928 346.498 206.928 347.397C206.928 348.297 191.121 330.679 177.742 340.4C164.363 350.121 176.83 370.497 176.83 370.497C176.83 370.497 160.728 365.027 161.024 370.805C161.32 376.583 176.227 381.461 176.227 381.461C176.227 381.461 149.172 384.196 158.905 396.356C168.637 408.516 195.076 399.695 195.076 399.695C195.076 399.695 187.771 407.604 192.945 408.515C198.119 409.427 217.809 393.929 219.691 389.974C221.574 386.019 231.851 374.144 224.853 362.304Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M285.06 399.612C285.06 399.612 294.946 399.091 300.156 390.767C305.365 382.444 303.27 376.713 295.42 373.599C287.57 370.485 276.689 372.036 276.689 372.036C276.689 372.036 260.077 351.222 236.658 356.384C213.238 361.546 210.113 379.803 211.675 389.169L217.927 426.642C217.927 426.642 237.179 429.768 242.388 424.559C247.598 419.349 257.473 400.618 267.88 398.025C278.287 395.432 285.06 399.612 285.06 399.612Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M288.529 417.561C287.89 422.238 284.539 428.809 281.318 428.371C278.098 427.933 275.99 423.801 276.582 419.124C277.174 414.447 280.596 413.796 283.817 414.234C287.037 414.672 289.157 412.896 288.529 417.561Z"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M233.011 412.103C233.011 412.103 237.179 413.666 243.43 408.989C249.682 404.312 249.67 392.851 263.203 390.246C276.736 387.642 285.581 393.893 286.102 397.54C286.623 401.187 284.539 408.468 284.539 415.75C284.539 423.031 286.102 426.678 287.665 428.241C289.228 429.804 291.3 428.762 288.186 431.888C285.289 434.443 282.148 436.708 278.808 438.648C278.808 438.648 269.964 455.307 266.329 458.421C262.694 461.535 253.838 459.984 250.712 458.421C247.586 456.858 240.826 453.223 240.826 453.223L236.658 467.798L211.676 447.552L217.927 426.737C217.927 426.737 230.418 423.552 233.011 412.103Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M240.826 453.223L234.124 445.61L237.735 461.511L240.826 453.223Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M280.466 419.03C280.288 421.031 279.282 422.582 278.169 422.475C277.056 422.368 276.357 420.675 276.535 418.663C276.713 416.65 277.719 415.111 278.832 415.217C279.945 415.324 280.608 417.017 280.466 419.03Z"
          fill="#263238"
        />
        <path
          d="M270.52 414.234L234.882 411.854"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M282.301 419.148H285.19"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M274.404 406.384C275.655 405.709 277.083 405.434 278.496 405.597C279.908 405.76 281.237 406.353 282.301 407.296"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M274.404 444.687C274.404 444.687 270.449 444.687 267.714 440.128"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M240.352 481.308L245.088 548.5H142.4C142.4 548.5 158.443 497.351 163.463 486.659C168.483 475.968 174.829 471.267 174.829 471.267C174.829 471.267 187.853 459.569 205.613 461.902C223.373 464.234 240.352 481.308 240.352 481.308Z"
          fill="#FF5A5F"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M236.137 416.271C236.137 416.271 234.053 405.863 226.772 407.426C219.49 408.989 223.125 425.115 227.813 429.804C232.502 434.492 235.616 429.283 235.616 429.283"
          fill="white"
        />
        <path
          d="M236.137 416.271C236.137 416.271 234.053 405.863 226.772 407.426C219.49 408.989 223.125 425.115 227.814 429.804C232.502 434.492 235.616 429.283 235.616 429.283"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M242.353 485.653C242.353 485.653 246.367 478.632 243.028 472.949C239.689 467.266 229.696 455.899 215.95 445.184C202.204 434.469 184.183 420.782 181.519 428.135C178.855 435.487 176.783 449.861 176.783 449.861C176.783 449.861 165.085 451.862 163.759 455.544C162.433 459.226 161.083 477.614 163.096 479.946C165.109 482.279 166.435 479.615 170.78 479.615C175.126 479.615 201.564 470.924 211.569 471.587C221.574 472.25 223.267 475.27 230.951 479.283C238.635 483.297 242.353 485.653 242.353 485.653Z"
          fill="#FF5A5F"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M235.486 473.529C237.383 474.917 239.125 476.505 240.684 478.265"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M184.811 456.657C192.459 455.07 201.742 454.229 208.254 457.237C216.519 461.114 224.441 465.685 231.934 470.9"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M171.147 460.576C174.958 459.157 178.858 457.99 182.821 457.083"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M181.152 449.92C181.152 449.92 189.511 446.581 200.878 450.252"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M193.88 483.983C196.556 478.3 205.246 465.596 218.626 472.286C232.005 478.975 235.332 495.018 241.358 514.744C247.385 534.469 253.056 548.5 253.056 548.5H203.245L190.873 498.689"
          fill="#FF5A5F"
        />
        <path
          d="M193.88 483.983C196.556 478.3 205.246 465.596 218.626 472.286C232.005 478.975 235.332 495.018 241.358 514.744C247.385 534.469 253.056 548.5 253.056 548.5H203.245L190.873 498.689"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M301.139 548.405L306.668 543.669C306.668 543.669 313.227 545.244 323.907 541.952C334.587 538.661 338.115 535.487 338.115 535.487C341.453 537.061 344.677 538.865 347.764 540.887C352.666 544.143 356.218 545.398 360.954 544.107C365.69 542.816 359.664 541.514 354.419 537.82C349.173 534.126 342.851 529.023 342.851 529.023C342.851 529.023 352.761 533.759 356.218 535.061C359.675 536.364 363.109 538.507 366.128 537.216C369.148 535.926 367.845 534.623 360.09 530.751C352.986 527.199 345.006 520.403 341.146 520.403C337.286 520.403 319.597 527.732 319.597 527.732L285.012 548.417L301.139 548.405Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M313.227 540.058C315.841 540.896 318.617 541.099 321.326 540.65C325.197 539.786 330.371 538.921 330.371 538.921C330.371 538.921 340.708 539.359 344.165 538.921C347.622 538.483 346.746 536.34 341.146 534.185C335.545 532.03 314.435 530.74 313.997 532.03C313.588 534.69 313.331 537.37 313.227 540.058Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M344.698 528.549C344.698 528.549 352.891 531.616 354.431 532.634C355.97 533.652 359.036 534.434 357.746 536.186C356.455 537.938 352.382 536.447 349.564 535.926C347.352 535.409 345.206 534.639 343.171 533.629L344.698 528.549Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M323.469 523.944C323.469 523.944 338.044 524.713 341.371 525.732C344.698 526.75 347.291 533.664 347.776 535.713C348.262 537.761 350.073 540.318 348.534 540.567C346.995 540.816 341.371 534.434 339.062 533.155C336.753 531.877 327.542 527.519 324.215 526.241C320.888 524.962 321.669 523.683 323.469 523.944Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M280.691 545.883C280.691 545.883 314.115 522.203 317.691 522.203C321.267 522.203 337.298 529.307 340.862 531.119C344.426 532.93 348.889 542.71 348.889 542.71C348.889 542.71 347.989 544.936 344.876 543.16C341.762 541.384 338.186 535.582 338.186 535.582L320.426 534.896C320.426 534.896 315.939 539.122 313.263 540.01C310.321 540.742 307.329 541.257 304.312 541.55L298.557 546.724L280.691 545.883Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M296.592 534.434L304.276 548.5H271.018L296.592 534.434Z"
          fill="#FF5A5F"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M282.857 413.559C282.857 413.559 272.853 409.889 271.515 412.233C270.177 414.578 268.851 423.233 274.191 426.903C279.53 430.573 282.301 419.148 282.301 419.148"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M312.576 183.52C336.771 183.52 356.384 163.906 356.384 139.712C356.384 115.517 336.771 95.9038 312.576 95.9038C288.382 95.9038 268.768 115.517 268.768 139.712C268.768 163.906 288.382 183.52 312.576 183.52Z"
          fill="#263238"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M312.576 178.748C334.135 178.748 351.613 161.271 351.613 139.712C351.613 118.153 334.135 100.675 312.576 100.675C291.017 100.675 273.54 118.153 273.54 139.712C273.54 161.271 291.017 178.748 312.576 178.748Z"
          fill="white"
          stroke="#263238"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M302.121 150.676L312.576 139.712L339.796 159.544"
          stroke="#263238"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p className="text-4xl text-center font-bold text-gray-700">
        This page is under construction.
      </p>
    </div>
  );
};

export default ComingSoon;
